export const GET_TRIALS = 'GET_TRIALS';
export const FILTER_TRIALS = 'FILTER_TRIALS';
export const ADD_TRIAL = 'ADD_TRIAL';
export const EDIT_TRIAL = 'EDIT_TRIAL';
export const GET_TRIAL = 'GET_TRIAL';
export const RESET_TRIAL = 'RESET_TRIAL';
export const TRIALS_ERROR = 'TRIALS_ERROR';
